<style scoped>
    .form-error{
        color:red;
        margin-left:0;
        margin-top:-14px
    }
</style>
<template>
    <form style="width:100%">
        <v-layout row wrap align-center  style="width:100%">
            <v-flex xs12>
                <v-form >
                    <v-flex xs12>
                        <v-form >
                            <v-layout row wrap align-center>
                                <v-flex xs12 style="margin-bottom:2rem">
                                    <div>
                                        <p style="margin-bottom:0" class="body-2">Device profile</p>
                                        <p style="margin-bottom:0" class="caption">Select existing device profile</p>
                                    </div>
                                    <v-select 
                                        :items="filteredDeviceProfiles"
                                        label="Select device profile" 
                                        item-value="id"
                                        item-text="id"
                                        v-model="model.device_profile"
                                        v-validate="'required'"
                                        ref="device_profile" 
                                        name="device_profile" 
                                    ></v-select>
                                    <div v-show="errors.first('device_profile')" class="form-error caption" style="text-align:left">{{errors.first('device_profile')}}</div>
                                </v-flex>
                            </v-layout>
                        </v-form>       
                    </v-flex>
                    <v-layout row wrap align-center>
                        <v-flex xs12 style="margin-bottom:2rem">
                            <div>
                                <p style="margin-bottom:0" class="body-2">Api-key</p>
                                <p style="margin-bottom:0" class="caption">Select existing api-key to enable uplink data over HTTP channel</p>
                            </div>
                            <v-select 
                                :items="apikeys"
                                label="Select api-key" 
                                item-value="value"
                                item-text="label"
                                v-model="model.apikey"
                                v-validate="'required'"
                                ref="apikey" 
                                name="apikey" 
                            ></v-select>
                            <div v-show="errors.first('apikey')" class="form-error caption" style="text-align:left">{{errors.first('apikey')}}</div>
                        </v-flex>
                    </v-layout>
                </v-form>       
            </v-flex>

        </v-layout>

        <v-btn block dark v-on:click="submit()" color="#39a9dc"> Submit </v-btn>
    </form>
</template>
<script>
import * as iotServicesSdk from 'iot-services-sdk';
export default {
    props:{
        apikeys: Array,
        model: Object,
        deviceProfiles: Array
    },
    
    created() {
        this.model.device_profile = undefined;
        this.model.apikey = undefined;
    },

    computed: {
        filteredDeviceProfiles(){
            return this.deviceProfiles.filter(dp => dp.connectivity === iotServicesSdk.shared.types.DeviceConnectivity.SIGFOX);
        },
    },

    methods: {
        async submit(){
            return new Promise(
                async (resolve,reject) => 
                    await this.$validator.validate()
                    .then( valid => { 
                            if(valid){
                                this.$emit("submit");
                                resolve();
                            }else{ 
                                reject();
                            } 
                        }
                    )
            );
        }
    }

}
</script>
